import AgrupadorApi from '../../servicos/agrupadorApi';

const obterCriterios = async (idDaListagemDeHabilitados, numeroDaInscricao) => {
  const criterios = await AgrupadorApi.obterCriterios(idDaListagemDeHabilitados, numeroDaInscricao);
  return criterios.data;
};

export default { obterCriterios };
